import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EVENT, NEW_RESERVATIONS, OLD_RESERVATION, PROFILES, RESERVATION, SLOT } from '../constants/storage-elements';
import { Event } from '../model/event.model';
import { Profile } from '../model/profile.model';
import { ExistingReservation, Reservation } from '../model/reservation.model';
import { Slot } from '../model/slot.model';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class HomeService {

  private errorMessage: string | undefined = undefined;

  private eventSubject = new BehaviorSubject<Event | undefined>(undefined);
  private reservationSubject = new BehaviorSubject<any | undefined>(undefined);
  private profilesSubject = new BehaviorSubject<Array<Profile> | undefined>(undefined);
  private slotSubject = new BehaviorSubject<Slot | undefined>(undefined);
  private newReservationsSubject = new BehaviorSubject<Reservation | undefined>(undefined);
  private editReservationSubject = new BehaviorSubject<ExistingReservation | undefined>(undefined);

  constructor(private sStorageService: SessionStorageService) { }

  setErrorMessage(message: string) {
    this.errorMessage = message;
  }

  getErrorMessage() {
    let tmp = this.errorMessage;
    this.errorMessage = undefined;
    return tmp;
  }

  saveEventObject(object: Event) {
    this.eventSubject.next(object);
    this.sStorageService.addElement(object, EVENT);
  }

  saveReservationObject(object: any) {
    this.eventSubject.next(object);
    this.sStorageService.addElement(object, RESERVATION);
  }

  getEventObject(): Event | undefined {
    let tmp = this.sStorageService.getElement(EVENT);
    if (tmp) {
      this.eventSubject.next(tmp);
    }

    return this.eventSubject.getValue();
  }

  getReservationObject(): any | undefined {
    let tmp = this.sStorageService.getElement(RESERVATION);
    if (tmp) {
      this.reservationSubject.next(tmp);
    }

    return this.reservationSubject.getValue();
  }

  saveProfileObject(object: Array<Profile>) {
    this.profilesSubject.next(object);
    this.sStorageService.addElement(object, PROFILES);
  }

  getProfileObject(): Array<Profile> | undefined {
    let tmp = this.sStorageService.getElement(PROFILES);
    if (tmp) {
      this.profilesSubject.next(tmp);
    }

    return this.profilesSubject.getValue();
  }

  saveSlotObject(object: Slot) {
    this.slotSubject.next(object);
    this.sStorageService.addElement(object, SLOT);
  }

  getSlotObject(): Slot | undefined {
    let tmp = this.sStorageService.getElement(SLOT);
    if (tmp) {
      this.slotSubject.next(tmp);
    }

    return this.slotSubject.getValue();
  }

  saveEditReservationObject(object: ExistingReservation) {
    this.editReservationSubject.next(object);
    this.sStorageService.addElement(object, OLD_RESERVATION);
  }

  getEditReservationObject(): ExistingReservation | undefined {
    let tmp = this.sStorageService.getElement(OLD_RESERVATION);
    if (tmp) {
      this.editReservationSubject.next(tmp);
    }

    return this.editReservationSubject.getValue();
  }

  saveNewReservationsObject(object: Reservation) {
    this.newReservationsSubject.next(object);
    this.sStorageService.addElement(object, NEW_RESERVATIONS);
  }

  getNewReservationsObject(): Reservation | undefined {
    let tmp = this.sStorageService.getElement(NEW_RESERVATIONS);
    if (tmp) {
      this.newReservationsSubject.next(tmp);
    }

    return this.newReservationsSubject.getValue();
  }

  clearSubject() {
    this.slotSubject.next(undefined);
    this.editReservationSubject.next(undefined);
    this.eventSubject.next(undefined);
    this.newReservationsSubject.next(undefined);
    this.profilesSubject.next(undefined);
  }

}
